<!-- Wrapper avec transition -->
<div @tooltip [ngClass]="tooltipClass">
    <!-- Template/Composant -->
    <ng-template #holder></ng-template>
</div>
